import { cloneDeep } from "lodash";
import { IAddEntityAction } from "./addEntity";
import { TFormBuilderEntityLifecycleSnapshot } from "../actionHelpers/entityLifecycleSnapshot";
import { IFormBuilderForm } from "../../model/formBuilderForm";

export interface IDeleteEntityActionPayload {
  snapshot: TFormBuilderEntityLifecycleSnapshot;
}

export interface IDeleteEntityAction {
  type: "DELETE_ENTITY";
  payload: IDeleteEntityActionPayload;
}

export function getDeleteEntityInverseAction(
  action: IDeleteEntityAction,
): IAddEntityAction {
  const { snapshot } = action.payload;

  return {
    type: "ADD_ENTITY",
    payload: {
      snapshot: cloneDeep(snapshot),
    },
  };
}

function deleteEntity(form: IFormBuilderForm, snapshot: TFormBuilderEntityLifecycleSnapshot): IFormBuilderForm {
  if (snapshot.type === "row") {
    const { entity } = snapshot;

    return {
      ...form,
      children: form.children.filter(row => row.key !== entity.key),
    };
  } else if (snapshot.type === "item") {
    const { origin, entity, parentRow } = snapshot;

    if (origin === "ADD_ENTITY") {
      if (parentRow.children.length <= 0) {
        return {
          ...form,
          children: form.children.filter(row => row.key !== parentRow.key),
        };
      } else {
        return {
          ...form,
          children: form.children.map(row => {
            if (row.key === parentRow.key) {
              return parentRow;
            } else {
              return row;
            }
          }),
        };
      }
    } else if (origin === "DELETE_ENTITY") {
      if (parentRow.children.length <= 1) {
        return {
          ...form,
          children: form.children.filter(row => row.key !== parentRow.key),
        };
      } else {
        return {
          ...form,
          children: form.children.map(row => {
            if (row.key === parentRow.key) {
              return {
                ...row,
                children: row.children.filter(item => item.key !== entity.key),
              };
            } else {
              return row;
            }
          }),
        };
      }
    } else {
      return form;
    }
  } else {
    return form;
  }
}

export function applyDeleteEntityChange(form: IFormBuilderForm, action: IDeleteEntityAction): IFormBuilderForm {
  const { snapshot } = action.payload;

  return deleteEntity(form, snapshot);
}